import piexif from 'piexifjs'

export default (value) => {
  return new Promise(function(resolve) {
    let canvas = document.createElement('canvas')
    let img = document.createElement("img");
    img.src = value
    setTimeout(() => {
      canvas.height=img.height
      canvas.width=img.width
      let ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      setTimeout(() => {
        let newImage = canvas.toDataURL('image/jpeg', 50/100);
        try {
          let metadata = piexif.load(value);
          metadata = piexif.dump(metadata);
          setTimeout(() => {
            resolve(piexif.insert(metadata,newImage))   
          }, 200);
        } catch(err) {
          resolve(newImage)
        }
      }, 200);
    }, 200);
})
}


// WEBPACK FOOTER //
// ./src/utils/reduceImageQuality.js